// extracted by mini-css-extract-plugin
export var root = "G_vJ";
export var wrapper = "G_vK";
export var image = "G_vL d_w d_y d_W";
export var imageWithHeight = "G_vM";
export var crop = "G_vN";
export var round = "G_vP";
export var fixedHeight = "G_vQ";